// extracted by mini-css-extract-plugin
export default {"heading":"cEjy0N","headingWrapper":"OX2LYN","subHeading":"Oge4OL"};